import React, { ReactNode } from 'react';
import { Icon, IconButton } from '@kontentino/ui';
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import clsx from 'clsx';

export type InfoBannerVariant = 'info' | 'warning';

const variantIcon: Record<InfoBannerVariant, IconDefinition> = {
  info: faCircleInfo,
  warning: faTriangleExclamation,
};

export interface InfoBannerProps {
  onClose?: () => void;
  content?: ReactNode;
  variant?: InfoBannerVariant;
  icon?: IconDefinition | null;
}

const InfoBanner = ({
  content,
  onClose,
  variant = 'info',
  icon,
}: InfoBannerProps) => {
  const resolvedIcon = icon === undefined ? variantIcon[variant] : icon;

  return (
    <div
      className={clsx(
        'tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center tw-gap-3 tw-py-3 tw-pl-8 tw-pr-[60px] tw-text-center',
        {
          'tw-bg-primary-10 tw-text-primary-120': variant === 'info',
          'tw-bg-warning-10 tw-text-warning-120': variant === 'warning',
        },
      )}
    >
      {resolvedIcon && <Icon icon={resolvedIcon} size="sm" />}
      <div>{content}</div>
      {!!onClose && (
        <div className="tw-absolute tw-right-4">
          <IconButton
            variant="plain"
            size="small"
            onClick={onClose}
            icon={<Icon icon={faClose} size="sm" />}
            data-cy="info-banner_close-button"
          />
        </div>
      )}
    </div>
  );
};

export default InfoBanner;
